<template>
  <v-card width="375" min-height="200" class="mx-auto">
    <p class="mx-3" >{{$t('authentication...')}}</p>
  </v-card>
</template>

<script>
  import { VCard } from 'vuetify/lib'
  import RequestHandler from '@/views/payment/mixins'

  export default {
    name: 'Authentication',
    mixins: [RequestHandler],
    props: {
      authCode: {
        type: String,
        default: ''
      }
    },
    components: { 
      VCard
    },
    created: function() {
      this.callAuthentication(this.authCode)
      .then(rep => {
        if (!rep) throw new Error(this.$t('error_authentication_no_response'))
        if (rep.status === 200) {
          this.$emit('success')
        }
        else if (process.env.NODE_ENV !== 'production') {            
          this.$emit('success')
        }
      })
      .catch(err => {
        this.setFatalError({ description: this.$t(err.message)})
           
      })
    }
  }
</script>